export const cognitoConfig = () => {
  return {
    clientId: process.env.REACT_APP_CLIENT_ID,
    identityPool: process.env.REACT_APP_IDENTITY_POOL,
    region: process.env.REACT_APP_REGION,
    userPool: process.env.REACT_APP_USER_POOL
  }
}
